import 'core-js/es/string/pad-start';
import 'core-js/es/math/trunc';
import * as React from 'react';
import './App.css';
import { Login } from './components/Login';
import { Uploader } from './components/Uploader';
import packageJson from '../package.json';

export interface UserState {
  expireSeconds: number,
  name: string,
  remainingTime: string,
  url: string,
  uploaded: boolean
}

class App extends React.Component<{}, UserState> {
  private intervalId: NodeJS.Timer | null;

  constructor(props: {}) {
    super(props);

    this.intervalId = null;
    this.state = {
      expireSeconds: Math.trunc(Date.now() / 1000),
      name: '',
      remainingTime: '',
      uploaded: false,
      url: '',
    };

    this.onUploaded = this.onUploaded.bind(this);
  }

  public render() {
    return (
      <div className={'App'}>
        <h1>調剤レセプト送信システム</h1>
        <div className={'Content'}>
          {this.userActive && this.userInfo}
          {this.userActive ? (
            <Uploader uploadUrl={this.state.url} onUploaded={this.onUploaded} />
          ) : (
            <Login onLoginSuccess={this.loginSuccess} uploaded={this.state.uploaded} />
          )}
        </div>
        <div className={'Footer'}>
          {packageJson.version} Copyright <a href="https://www.intage-realworld.co.jp/" target="_blank" rel="external noopener noreferrer">INTAGE Real World Inc.</a>
        </div>
      </div>
    );
  }

  public componentDidMount() {
    this.intervalId = setInterval(() => {
      this.setState({ remainingTime: this.formatTime(this.remainingSeconds) });
    }, 1000);
  }

  public componentWillUnmount() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
    this.intervalId = null;
  }

  private get userActive() {
    return !!(this.state.url && this.remainingSeconds > 0);
  }

  private get remainingSeconds() {
    return this.state.expireSeconds - Math.trunc(Date.now() / 1000);
  }

  private formatTime(remainingSeconds: number) {
    const min = String(Math.trunc(remainingSeconds / 60)).padStart(2, '0');
    const sec = String(remainingSeconds % 60).padStart(2, '0');
    return `${min}:${sec}`;
  }

  private get userInfo() {
    return (
      <div className={'User-Info'}>
        <div>{this.state.name} でログイン中</div>
        <div>残り時間: {this.state.remainingTime}</div>
      </div>
    );
  }

  private onUploaded() {
    this.setState({ name: '', uploaded: true, url: '', });
  }

  private loginSuccess = (state: UserState) => {
    this.setState(state);
    this.setState({ expireSeconds: Math.trunc(Date.now() / 1000) + (30 * 60) }); // remaining time is 30 minutes
    this.setState({ uploaded: false });
    // for Chrome password saver
    window.history.pushState({ name: 'uploader' }, '', '/');
  }
}

export default App;
